import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class FaqErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/faq\/all/,
      messages: {
        400: 'errors.getFaqFailed',
        404: 'errors.getFaqFailed',
        500: 'errors.getFaqFailed',
        success: {
          default: 'errors.getFaqFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
